<div class="entra-login-container">
    <button type="submit" class="entra-login-button" (click)="loginToEntra()"
        [disabled]="loggingIn || isAuthInProgress || !msalInitialized">
        <svg class="microsoft-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
            <rect x="1" y="1" width="10" height="10" fill="#f25022"/>
            <rect x="12" y="1" width="10" height="10" fill="#7fba00"/>
            <rect x="1" y="12" width="10" height="10" fill="#00a4ef"/>
            <rect x="12" y="12" width="10" height="10" fill="#ffb900"/>
        </svg>
        <span *ngIf="!loggingIn && !isAuthInProgress">Sign in with Microsoft</span>
        <span *ngIf="loggingIn || isAuthInProgress">Signing in...</span>
    </button>

    <div class="error-message" *ngIf="error">
        <span>{{errorMessage}}</span>
    </div>
</div>